export const environment = {
  production: false,
  apiCosta: 'https://training.costaextra.it',
  cws: 'https://apidev.cws.otosrl.com/v2',
  nexi: 'https://int-ecommerce.nexi.it/ecomm/ecomm/DispatcherServlet',
  sso: 'https://training.costaextra.it/CostaClick/it-IT/LoggedOn/Pages/OtoLoginAreaMerchandising.aspx',
  ga: 'G-3WKQ838H0N'
};
